import { DateRangeFilter } from "../../UI/Table/Filters/DateRangeFilter.tsx";
import { AmountRangeFilter } from "../../UI/Table/Filters/AmountRangeFilter.tsx";
import { CountRangeFilter } from "../../UI/Table/Filters/CountRangeFilter.tsx";
import {
  SalesColumnFilter,
  SalesColumnFilterValue,
  valueOptionsOf,
} from "./salesColumnFilters.ts";
import { ColumnValuesFilter } from "./ColumnValuesFilter.tsx";

export function ColumnFilterPanel<Row>({
  filter,
  unfilteredRows,
  value,
  onApply,
  close,
}: {
  filter: SalesColumnFilter<Row>;
  unfilteredRows: Row[];
  value?: SalesColumnFilterValue;
  onApply: (value: SalesColumnFilterValue) => void;
  close: () => void;
}) {
  switch (filter.kind) {
    case "values": {
      const selected = value?.kind === "values" ? value.selected : [];
      return (
        <ColumnValuesFilter
          options={valueOptionsOf(unfilteredRows, filter.valuesOf, selected)}
          value={selected}
          onApply={(chosen) => onApply({ kind: "values", selected: chosen })}
          close={close}
        />
      );
    }
    case "dateRange":
      return (
        <DateRangeFilter
          value={value?.kind === "dateRange" ? value : {}}
          onApply={({ from, to }) => onApply({ kind: "dateRange", from, to })}
          close={close}
        />
      );
    case "amountRange":
      return (
        <AmountRangeFilter
          value={value?.kind === "amountRange" ? value : {}}
          onApply={({ minInCents, maxInCents }) =>
            onApply({ kind: "amountRange", minInCents, maxInCents })
          }
          close={close}
        />
      );
    case "countRange":
      return (
        <CountRangeFilter
          value={value?.kind === "countRange" ? value : {}}
          onApply={({ min, max }) => onApply({ kind: "countRange", min, max })}
          close={close}
        />
      );
  }
}
